import { useState } from 'react';

// material ui
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import { IoIosCash } from 'react-icons/io';

// interfaces

interface IProps {
  cashBalance: string;
}

export const CashBalanceCard = ({ cashBalance }: IProps) => {
  return (
    <>
      <Box sx={{ background: '#dfecf1' }} p={3}>
        <Grid container spacing={2}>
          <Grid size={8}>
            <Grid container spacing={2}>
              <Grid size={3}>
                <Card sx={{ background: '#d0e1e9' }}>
                  <CardContent>
                    <IoIosCash fontSize={25} />

                    <Typography variant="h5" fontWeight={900} gutterBottom>
                      ₱{cashBalance}
                    </Typography>
                    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} display={'flex'}>
                      <Stack direction={'column'}>
                        <Typography variant="caption">Cash Balance</Typography>
                        {/* <Typography variant="caption">Total Amount</Typography> */}
                      </Stack>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
              <Grid size={3}></Grid>
            </Grid>
          </Grid>
          <Grid size={4}></Grid>
        </Grid>
      </Box>
    </>
  );
};
